import { Uppy } from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';
import ThumbnailGenerator from '@uppy/thumbnail-generator';
import { find, filter, keys, each, countBy } from "lodash";
import app from '../../angular_app.es6';

app.directive('sourceUploader', [ '$timeout', 'Notification', ($timeout, Notification) => {
  return {
    restrict: 'A',
    scope: {
      source: '=sourceUploader',
      sourceNotDeletedField: '@',
      sourceField: '@',
      imageField: '@',
      onFinishItemCallback: '=',
      onInitCallback: '&',
      sourceGenerator: '&',
      dragDropPlaceholder: '@',
      maxImageQty: "=?",
      maxToUpload: "=?"
    },
    link: ($scope, $element) => {
      $scope.multiple = $element[0].multiple;

      // private

      let _imagesQty = { total: 0, exceed: 0 };

      const fileInput = $element[0];

      const uppyId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

      const uppy = _fileUpload(fileInput);

      uppy.use(ThumbnailGenerator, { id: uppyId, thumbnailWidth: 800 });

      const _addSourceOrGetExisting = (file) => {
        if (Array.isArray($scope.source)) {
          let item = find($scope.source, (e) => e._source_id == file.id);
          if (!item) {
            item = $scope.sourceGenerator()();
            item.name = file.name;
            item._source_id = file.id;
            item.loading = true;
            $scope.source.push(item);
            $timeout(() => {});
          }
          return item;
        }

        return $scope.source;
      };

      const _fileAdded = (file) => {
        uppy.upload();
        if ($scope.onInitCallback && $scope.onInitCallback()) { $scope.onInitCallback()(file); }
        _addSourceOrGetExisting(file);
      };

      const _waitForThumbnail = (source, uploadedFileData, n) => {
        if (!!source[`${$scope.imageField}_src`] || n > 10) {
          $timeout(() => {
            source[`${$scope.sourceField}_data`] = uploadedFileData;
            if ($scope.onFinishItemCallback) { $scope.onFinishItemCallback(source); }
          });
        } else {
          $timeout(() => {
            _waitForThumbnail(source, uploadedFileData, n + 1);
          }, 100);
        }
      };

      const _onUploadSuccess = function (file, response) {
        const uploadedFileData = _uploadedFileData(file);

        const source = _addSourceOrGetExisting(file);

        _waitForThumbnail(source, uploadedFileData, 0);
      };

      const _onThumbnailGenerator = function (file, preview) {
        const source = _addSourceOrGetExisting(file);

        $timeout(() => {
          source[`${$scope.imageField}_src`] = preview;
        });
      };

      const _onComplete = function () {
        if (_imagesQty.exceed > 0) {
          _imagesQty = { total: 0, exceed: 0 };
          Notification.error("Some of the concepts were not uploaded due to the limit");
        }
      };

      uppy.on('file-added', _fileAdded);
      uppy.on('upload-success', _onUploadSuccess);
      uppy.on('thumbnail:generated', _onThumbnailGenerator);
      uppy.on('complete', _onComplete);

      function _fileUpload(fileInput, _uppy) {
        const maxNumberOfFiles = $scope.multiple ? null : 1;
        const uppy = new Uppy({
          id: uppyId,
          onBeforeFileAdded: (currentFile, files) => {
            _imagesQty.total += 1;
            const listOfSource = $scope.sourceNotDeletedField ?
              filter($scope.source, (el) => !el[$scope.sourceNotDeletedField]) : $scope.source;

            let inListCnt;
            if (Array.isArray(listOfSource)) {
              inListCnt = countBy(listOfSource, (el) => (!el._destroy));
            } else {
              inListCnt = listOfSource._destroy ? 1 : 0;
            }

            if (!!$scope.maxImageQty && $scope.maxImageQty <= inListCnt) {
              _imagesQty.exceed += 1;
              return false;
            }

            if (maxNumberOfFiles === 1) {
              // https://github.com/transloadit/uppy/issues/1575
              // need to reset files or user can upload file only once
              each(keys(files), (key) => {
                delete files[key];
              });
            } else {
              // need to remove file for re uploading
              each(keys(files), (key) => {
                if (files[key]['data']['name'] === currentFile['data']['name']) {
                  if (JSON.stringify(files[key]['data']) === JSON.stringify(currentFile['data'])) {
                    delete files[key];
                  }
                }
              });
            }
            return currentFile;
          }
        });
        uppy.use(AwsS3, {
          endpoint: '/' // will call Shrine's presign endpoint mounted on `/s3/params`
        });

        fileInput.onchange = (event) => {
          let files = Array.from(event.target.files);
          if (maxNumberOfFiles) {
            files = [ files[0] ];
          }
          if (!files.length) {
            return;
          }
          const resetFiles = () => {
            uppy.getState().files = {};
            uppy.getState().totalProgress = null;
          };
          if (!keys(uppy.store.state.files).length) {
            resetFiles();
          }
          fileInput.value = '';
          let uploadCounter = keys(uppy.getState().files)?.length || 0;
          each(files, (file) => {
            if (!$scope.maxToUpload || $scope.maxToUpload > uploadCounter) {
              uppy.addFile({
                source: 'file input',
                name: file.name,
                type: file.type,
                data: file
              });
              uploadCounter += 1;
            }
          });
        };


        return uppy;
      }

      function _uploadedFileData(file, response) {
        // construct uploaded file data in the format that Shrine expects
        return JSON.stringify({
          id: file.s3Multipart['key'].match(/^cache\/(.+)/)[1], // object key without prefix
          storage: 'cache',
          metadata: {
            size: file.size,
            filename: file.name,
            mime_type: file.type
          }
        });
      }
    }
  };
} ]);
